import { render } from "./BaseChart.vue?vue&type=template&id=d94ebea8"
import script from "./BaseChart.vue?vue&type=script&lang=js"
export * from "./BaseChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__